<template>
  <Screen :menu="false" title="DIY cardmaker">
    <div class="splash-container">
      
      <!-- Center Ribbon Banner -->
      <div class="banner-wrapper">
        <!-- Washi Tapes -->
        <img src="../assets/washi/Washi-tape-top-left.svg" class="washi washi-tl" alt="" />
        <img src="../assets/washi/Washi-tape-top-right.svg" class="washi washi-tr" alt="" />
        <img src="../assets/washi/Washi-tape-bottom-right.svg" class="washi washi-br" alt="" />
        <img src="../assets/washi/Washi-tape-bottom-left.svg" class="washi washi-bl" alt="" />

        <!-- Ribbon SVG Background -->
        <svg class="ribbon-bg" viewBox="0 0 600 120" preserveAspectRatio="none">
          <polygon 
            points="30,0 570,0 600,60 570,120 30,120 0,60" 
            fill="var(--surface-darker)" 
            stroke="var(--surface-darkest)" 
            stroke-width="3" 
            vector-effect="non-scaling-stroke"
            filter="url(#sketchy-border)" 
          />
        </svg>

        <!-- Animated Text -->
        <h1 class="banner-text" aria-label="DIY CARDMAKER">
          <span class="banner-text__shadow">
            <span v-for="(char, i) in textArray" :key="'s'+i" class="char" :style="{ animationDelay: (i * 0.1) + 's' }">
              {{ char === ' ' ? '&nbsp;' : char }}
            </span>
          </span>
          <span class="banner-text__fg">
            <span v-for="(char, i) in textArray" :key="'f'+i" class="char" :style="{ animationDelay: (i * 0.1) + 's' }">
              {{ char === ' ' ? '&nbsp;' : char }}
            </span>
          </span>
        </h1>
      </div>

    </div>
  </Screen>
</template>

<script>
import Screen from './Screen.vue';

export default {
  name: 'SplashScreen',
  components: {
    Screen
  },
  data() {
    return {
      textArray: 'DIY CARDMAKER'.split('')
    }
  },
  mounted() {
    // Navigates to ChooseFoldScreen after the animation completes
    // Text: 13 chars * 0.1s = 1.3s
    // Tapes: end at 2.1s + 0.3s = 2.4s
    // Give user a moment to see the full screen before transitioning.
    setTimeout(() => {
      this.$store.commit('setScreen', 'ChooseFoldScreen');
    }, 4500); // Wait 4.5 seconds total
  }
}
</script>

<style scoped>
/* ── Hide default nav title text ── */
:deep(.title) {
  display: none;
}

.splash-container {
  flex-grow: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}

.banner-wrapper {
  position: relative;
  width: 90%;
  max-width: 700px;
  height: 120px;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* ── Ribbon Background ── */
.ribbon-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
  overflow: visible; /* Let the stroke bleed */
}

/* ── Animated Text ── */
.banner-text {
  position: relative;
  z-index: 2;
  font-family: Cabin-Sketch, cursive;
  font-weight: bold;
  text-transform: uppercase;
  font-size: 8vw;
  margin: 0;
  line-height: 1;
  text-align: center;
}

@media screen and (min-width: 800px) {
  .banner-text {
    font-size: 64px;
  }
}

.banner-text__shadow {
  position: absolute;
  left: 4px;
  top: 4px;
  width: 100%;
  color: var(--surface-darkest);
  display: flex;
  justify-content: center;
}

.banner-text__fg {
  position: relative;
  color: var(--green-lightest);
  display: flex;
  justify-content: center;
  /* Text stroke for the foreground layer */
  -webkit-text-stroke: 1px var(--surface-darkest);
  paint-order: stroke fill;
}

/* ── Character Animation ── */
.char {
  opacity: 0;
  animation: revealChar 0.1s forwards linear;
}

@keyframes revealChar {
  0% { opacity: 0; }
  100% { opacity: 1; }
}

/* ── Washi Tape ── */
.washi {
  position: absolute;
  z-index: 3;
  width: 80px; /* Base size, adjust based on actual SVGs */
  height: auto;
  opacity: 0;
  animation: popWashi 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275) forwards;
}

/* Position and stagger delays */
.washi-tl { top: -20px; left: 10px; animation-delay: 1.5s; }
.washi-tr { top: -10px; right: 10px; animation-delay: 1.8s; }
.washi-bl { bottom: -20px; left: 20px; animation-delay: 2.1s; }
.washi-br { bottom: -10px; right: 10px; animation-delay: 2.4s; }

@media screen and (max-width: 600px) {
  .washi { width: 60px; }
  .washi-tl { left: -5px; }
  .washi-tr { right: -5px; }
  .washi-bl { left: 0px; }
  .washi-br { right: -10px; }
}

@keyframes popWashi {
  0% { 
    opacity: 0; 
    transform: scale(0.2) translateY(-20px); 
  }
  100% { 
    opacity: 1; 
    transform: scale(1) translateY(0); 
  }
}
</style>